import { VueConstructor } from 'vue';
import VueI18n from 'vue-i18n';
const langtpl = require('./assets/language.tpl.json'); // tslint:disable-line

let plugin: VueI18n | undefined;

const loadedLanguages: string[] = [];

export function getI18n(): VueI18n {
    if (plugin === undefined) {
        throw new Error('I18n not registered. Did you call register()?');
    }
    return plugin;
}

function updateLanguage(lang: string) {
    const i18n = getI18n();

    i18n.locale = lang;
    const html = document.querySelector('html');
    if (html) { html.setAttribute('lang', lang); }
    localStorage.setItem('lang', lang);
    return lang;
}

export function register(Vue: VueConstructor, lang: string) {
    const messages = {
        'x-initlang': langtpl
    };
    Vue.use(VueI18n);
    plugin = new VueI18n({
        locale: 'x-initlang',
        fallbackLocale: lang,
        messages
    });
    return loadLanguageAsync(lang);
}

export function loadLanguageAsync(lang: string) {
    const i18n = getI18n();
    console.log(lang);
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            const request = new XMLHttpRequest();
            return new Promise<XMLHttpRequest>((resolve, reject) => {
                request.responseType = 'json';
                request.onreadystatechange = () => {
                    if (request.readyState !== XMLHttpRequest.DONE) { return; }
                    if (request.status >= 200 && request.status < 300) {
                        resolve(request);
                    } else {
                        reject({
                            status: request.status,
                            statusText: request.statusText
                        });
                    }
                };
                request.open('GET', '/lang/' + lang + '.json', true);
                request.send();
            }).then((resp) => {
                return resp.response;
            }).then((msgs) => {
                    i18n.setLocaleMessage(lang, msgs);
                    loadedLanguages.push(lang);
                    return updateLanguage(lang);
                });
        }
        return Promise.resolve(updateLanguage(lang));
    }
    return Promise.resolve(lang);
}
